import { IFRAME_STYLE_CSS } from "../constants";

export const loadIframeStyle = () => {
    const style = document.createElement("style");
    style.innerHTML = IFRAME_STYLE_CSS;
    const head = document.getElementsByTagName("head")[0];
    head.appendChild(style);
};
